import { render, staticRenderFns } from "./page.vue?vue&type=template&id=d54169be&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.vue?vue&type=style&index=0&id=d54169be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54169be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d54169be')) {
      api.createRecord('d54169be', component.options)
    } else {
      api.reload('d54169be', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=d54169be&scoped=true&", function () {
      api.rerender('d54169be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/nftCollection/page.vue"
export default component.exports